<div class="mb-4 flex flex-col w-full bg-white border border-gray-200 shadow-sm rounded-sm">
  <div class="border-b border-b-gray-200 flex justify-between">
    <div class="flex">
      <app-dropdown
        [collection]="dataSources"
        [(value)]="dataSource"
        (valueChange)="dataSourceChanged($event)"
        selectable="multiple"
      >
        <lucide-icon [name]="Database" size="16"></lucide-icon>
        {{ 'common.graph.dataSources' | translate }}
      </app-dropdown>

      <app-dropdown
        [collection]="visualizations"
        [(value)]="selectedType"
        (valueChange)="visualizationChanged($event)"
      >
        <lucide-icon [name]="ChartLine" size="16"></lucide-icon>
        {{ 'common.graph.visualization' | translate }}
      </app-dropdown>

      @if (!config || config.dateRange) {
        <app-dropdown [directContent]="true">
          <lucide-icon [name]="Calendar" size="16"></lucide-icon>
          {{ 'common.graph.dateRange' | translate }}
          <div content>
            <form [formGroup]="dateForm">
              <app-input-group>
                <label appLabel>{{ 'common.date.start' | translate }}</label>
                <input appInputDate formControlName="start">
              </app-input-group>

              <app-input-group>
                <label appLabel>{{ 'common.date.end' | translate }}</label>
                <input appInputDate formControlName="end">
              </app-input-group>

              <button
                appButton
                type="secondary"
                (click)="fetchData()"
              >
                {{ 'common.search' | translate }}
              </button>
            </form>
          </div>
        </app-dropdown>
      }
    </div>
    <div class="flex">
      <app-dropdown
        [directContent]="true"
        [right]="false"
      >
        <lucide-icon [name]="Settings2" size="16"></lucide-icon>
        <div content>
          <app-input-group>
            <label class="ec-toggle-label">
              {{ 'common.graph.legend' | translate }}
              <app-toggle [(ngModel)]="showLegend" (ngModelChange)="toggleLegend($event)"></app-toggle>
            </label>
          </app-input-group>

          @if (details && details.length > 0) {
            <app-input-group>
              <label class="ec-toggle-label">
                {{ 'common.graph.details' | translate }}
                <app-toggle [(ngModel)]="showDetails" (ngModelChange)="showDetails = $event"></app-toggle>
              </label>
            </app-input-group>
          }
        </div>
      </app-dropdown>

      @if (config?.reset === undefined || config?.reset) {
        <button
          class="flex gap-2 align-middle justify-center text-sm text-secondary px-3 py-3 border-l border-gray-200 hover:bg-gray-50 hover:text-primary"
          (click)="reset()"
        >
          {{ 'common.reset' | translate }}
        </button>
      }
    </div>
  </div>
  <div class="flex gap-4">
    <div
      class="p-5 w-full max-h-[60svh] relative"
      [ngClass]="[showDetails ? 'w-5/6' : 'w-full']"
    >
      @if (loading) {
        <app-loading-overlay></app-loading-overlay>
      }
      <!-- Inner wrapper gives the selection box an accurate positioning context
           that matches the canvas coordinate space (offsetX/offsetY). -->
      <div class="relative w-full h-full">
        <canvas
          class="w-full h-full cursor-crosshair select-none"
          #chartCanvas
          (mousedown)="onMouseDown($event)"
        ></canvas>
        @if (selectionActive) {
          <div
            class="absolute pointer-events-none rounded-sm border border-blue-500/70 bg-blue-500/10"
            [style.left.px]="selBox.left"
            [style.top.px]="selBox.top"
            [style.width.px]="selBox.width"
            [style.height.px]="selBox.height"
          ></div>
        }
      </div>
    </div>
    @if (showDetails) {
      <div class="pt-5 pr-5 w-1/6 flex flex-col gap-4">
        @for (d of details; track d.id; let i = $index) {
          <div class="text-sm p-2 bg-gray-50 rounded-md flex flex-col gap-2">
            <div class="font-semibold">{{ d.id }}</div>
            <div class="flex gap-2 justify-between">
              <div class="text-secondary">
                {{ 'common.graph.min' | translate }}
              </div>
              <div class="text-right">
                {{ d.min | number: '1.2-2' }} kWh
              </div>
            </div>
            <div class="flex gap-2 justify-between">
              <div class="text-secondary">
                {{ 'common.graph.max' | translate }}
              </div>
              <div class="text-right">
                {{ d.max | number: '1.2-2' }} kWh
              </div>
            </div>
            <div class="flex gap-2 justify-between">
              <div class="text-secondary">
                {{ 'common.graph.average' | translate }}
              </div>
              <div class="text-right">
                {{ d.average | number: '1.2-2' }} kWh
              </div>
            </div>
            @if (d.median) {
              <div class="flex gap-2 justify-between">
                <div class="text-secondary">
                  {{ 'common.graph.median' | translate }}
                </div>
                <div class="text-right">
                  {{ d.median | number: '1.2-2' }} kWh
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
